import ftm2021_results from "./results_file/ftm2021_results.docx";

export const resultsLinks = [
  {
    id: 0,
    label: `Спортивные результаты сезона (2021 г.)`,
    file: ftm2021_results,
  },
];
